/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		12: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunk-" + ({"0":"contacts","1":"core-js","2":"index","3":"documents","4":"company","5":"progress","6":"news","7":"decoration","8":"buy","9":"choose","10":"choose-apartment","11":"choose-card"}[chunkId]||chunkId) + "." + {"0":"1adb68dfcecc3e07174d","1":"8424e0fd4964bc0b9755","2":"474f2039d4e80b3d514e","3":"af9d9f6f884f8ca9c768","4":"a65cd9eba6dfe862086c","5":"ae9181b800a2543e01e2","6":"bce744ff2187898c5fd4","7":"87daf52e9ac4608f9441","8":"7441a6a2c7f3625aa86d","9":"9adc35209a82c650ed2b","10":"c58717c55a8d9fb27cd2","11":"ecda4c5b2a23c35e7622"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/scripts/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "+wwp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wait; });

// Wait for a specified amount of time, then return a promise.
/**
 * Wait for a specified amount of time, then return a promise.
 *
 * @param ms The amount of milliseconds you want to wait.
 * @returns Promise.
 */
function wait(ms) {
    return new Promise(function (resolve) {
        return setTimeout(resolve, ms);
    });
}
/**
 * Module
 */



/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("BaBS");


/***/ }),

/***/ "A8oM":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(root, factory) {
     true ? // AMD. Register as an anonymous module unless amdModuleId is set
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return root.svg4everybody = factory();
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.8 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent);
                if (svg) {
                    var src = use.getAttribute("xlink:href") || use.getAttribute("href");
                    !src && opts.attributeName && (src = use.getAttribute(opts.attributeName));
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});

/***/ }),

/***/ "BaBS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/custom-event-polyfill/custom-event-polyfill.js
var custom_event_polyfill = __webpack_require__("brk0");
var custom_event_polyfill_default = /*#__PURE__*/__webpack_require__.n(custom_event_polyfill);

// EXTERNAL MODULE: ../node_modules/svg4everybody/dist/svg4everybody.js
var svg4everybody = __webpack_require__("A8oM");
var svg4everybody_default = /*#__PURE__*/__webpack_require__.n(svg4everybody);

// EXTERNAL MODULE: ./app/elements/Lightbox.ts
var Lightbox = __webpack_require__("FK8Y");

// CONCATENATED MODULE: ./app/Common/Forms/index.ts

// Инициализация форм документа.

/**
 * Класс, назначаемый после успешной отправки формы.
 */
var CLASS_SUCCESS = 'success';
/**
 * Класс, назначаемый на время отправки формы.
 */
var CLASS_PROGRESS = 'progress';
/**
 * Инициализация форм документа.
 */
function main() {
    for (var i = 0, n = document.forms.length; i < n; i++) {
        initForm(document.forms.item(i));
    }
}
/**
 * Инициализация формы.
 */
function initForm(form) {
    if (form.dataset.ajax !== 'true') {
        return;
    }
    var btnSubmit = form.querySelector('button[type="submit"]');
    if (!btnSubmit) {
        return;
    }
    var btnOk = form.querySelector('div.success button');
    var lightbox = Lightbox["a" /* default */].instance;
    if (btnOk) {
        btnOk.addEventListener('click', function () {
            lightbox.close();
            form.classList.remove(CLASS_SUCCESS);
        });
    }
    form.addEventListener('submit', function (event) {
        event.preventDefault();
        var xhr = new XMLHttpRequest();
        var data = new FormData(form);
        data.append('pageUrl', window.location.href);
        btnSubmit.blur();
        xhr.onload = function () {
            form.classList.remove(CLASS_PROGRESS);
            if (xhr.status < 400) {
                form.classList.add(CLASS_SUCCESS);
            }
        };
        form.classList.add(CLASS_PROGRESS);
        xhr.open('POST' /*form.method*/, form.action);
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.send(data);
        if (form.dataset.tracking) {
            try {
                // tslint:disable-next-line:no-non-null-assertion
                var trackingData = JSON.parse(form.dataset.tracking);
                if (Array.isArray(trackingData)) {
                    sendTracking(trackingData);
                }
            }
            catch (error) {
                console.error(error);
            }
        }
    });
}
/**
 * Отправляет данные отслеживания.
 *
 * @param data Данные события.
 */
function sendTracking(data) {
    var ga = window.ga;
    if (!ga) {
        return;
    }
    ga.apply(null, [
        ga.getAll()[0].get('name') + '.send'
    ].concat(data));
}
/**
 * Module.
 */


// EXTERNAL MODULE: ./app/utils/convertLinkToImage.ts
var convertLinkToImage = __webpack_require__("Z3hk");

// EXTERNAL MODULE: ./app/utils/isIntersectionObserverSupported.ts
var isIntersectionObserverSupported = __webpack_require__("z9xy");

// CONCATENATED MODULE: ./app/Common/LazyImage/index.ts



/**
 * Инициализирует ленивые изображения.
 *
 * Превращение ссылок на изображения, с классом `lazy-image`, в изображения.
 */
function LazyImage_main() {
    var links = new Set(Array.from(document.querySelectorAll('a.lazy-image')));
    if (!Object(isIntersectionObserverSupported["a" /* default */])()) {
        links.forEach(function (element) {
            Object(convertLinkToImage["a" /* default */])(element);
        });
        return;
    }
    var onIntersection = function (entries) {
        for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
            var entry = entries_1[_i];
            if (!entry.isIntersecting) {
                continue;
            }
            var element = entry.target;
            Object(convertLinkToImage["a" /* default */])(element);
            observer.unobserve(element);
        }
    };
    var observer = new IntersectionObserver(onIntersection);
    links.forEach(function (element) {
        observer.observe(element);
        links.delete(element);
    });
}
/**
 * Module.
 */


// EXTERNAL MODULE: ./app/utils/Screen.ts
var Screen = __webpack_require__("PTul");

// CONCATENATED MODULE: ./app/Common/Lightbox/index.ts



/**
 * Инициализирует глобальные настройки лайтбокса
 */
function Lightbox_main() {
    Object(Screen["a" /* addScreenModeListener */])(function (mode) {
        Lightbox["a" /* default */].toggleFullScreenMode(mode < 2 /* NOTEBOOK */);
    });
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Common/MainMenu/index.ts

// Инициализация главного меню
/**
 * Инициализация главного меню
 */
function MainMenu_main() {
    var panel = document.querySelector('body>nav.main');
    var menuList = panel.querySelector('ul.menu');
    if (!panel || !menuList) {
        return;
    }
    panel.addEventListener('click', function (event) {
        if ((event.target.tagName === 'A')
            || !menuList.contains(event.target)) {
            panel.classList.toggle('open');
        }
    });
    if (window.location.pathname === '/') {
        return;
    }
    var logo = panel.querySelector('div.logo');
    if (!logo) {
        return;
    }
    logo.classList.add('clickable');
    logo.addEventListener('click', function (event) {
        if (!panel.classList.contains('open')) {
            return;
        }
        event.stopPropagation();
        window.location.href = '/';
    });
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Common/index.ts

// Общие модули сайта




/**
 * Общие модули сайта
 */
function Common_main() {
    MainMenu_main();
    main();
    LazyImage_main();
    Lightbox_main();
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/Routes/index.ts

/**
 * Загрузка скриптов в зависимости от текущего адреса
 */
function Routes_main() {
    var path = window.location.pathname;
    switch (path) {
        case '/':
            __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "UYGi"))
                .then(function (module) { return module.default(); });
            break;
        case '/buy/':
            __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "IUWV"))
                .then(function (module) { return module.default(); });
            break;
        case '/commercial/':
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "5Zht"))
                .then(function (module) { return module.default(); });
            break;
        case '/contacts/':
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Y1oM"))
                .then(function (module) { return module.default(); });
            break;
        case '/decoration/':
            __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "Rvxz"))
                .then(function (module) { return module.default(); });
            break;
        case '/documents/':
            __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "ylc5"))
                .then(function (module) { return module.default(); });
            break;
        case '/news/':
            __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "BzIo"))
                .then(function (module) { return module.default(); });
            break;
        case '/progress/':
            __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "Anur"))
                .then(function (module) { return module.default(); });
            break;
        case '/company/':
            __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "BOmR"))
                .then(function (module) { return module.default(); });
            break;
        default:
            if (/^\/choose\//.test(path)) {
                __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "Zec3"))
                    .then(function (module) { return module.default(); });
            }
            break;
    }
}
/**
 * Module
 */


// CONCATENATED MODULE: ./app/index.ts





if (
// ES2016
!Array.prototype.includes
    // ES2015
    || !window.WeakSet
    || !window.Symbol
    || !Array.from
    || !Object.assign) {
    __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "8w2b"))
        .then(app);
}
else {
    app();
}
function app() {
    Common_main();
    Routes_main();
}


/***/ }),

/***/ "FK8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Lightbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__("vCxL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__ = __webpack_require__("+wwp");

// Lightbox singleton


/**
 * Lightbox singleton
 */
var Lightbox = /** @class */ (function () {
    /**
     * Lightbox singleton
     */
    function Lightbox() {
        var _this = this;
        /**
         * Listener for keystrokes on Document
         */
        this.onDocumentKeyUp = function (event) {
            if (event.keyCode === 27 /* Escape */) {
                _this.close();
            }
        };
        /**
         * Handle touch start to save initial Y position.
         */
        this.onLightboxTouchStart = function (event) {
            if (event.targetTouches.length === 1) {
                _this.initialTouchY = event.targetTouches[0].clientY;
            }
        };
        /**
         * Handle touch move to prevent body scroll on mobile devices.
         */
        this.onLightboxTouchMove = function (event) {
            if (Lightbox.fullScreenMode
                || (event.targetTouches.length !== 1)) {
                return;
            }
            var distance = event.targetTouches[0].clientY - _this.initialTouchY;
            if ((distance > 0)
                && (_this.element.scrollTop === 0)) {
                event.preventDefault();
                return;
            }
            if ((distance < 0)
                && ((_this.element.scrollHeight - _this.element.scrollTop)
                    <= _this.element.clientHeight)) {
                event.preventDefault();
            }
        };
        if (Lightbox._instance) {
            return Lightbox._instance;
        }
        this.createElements();
        this.contentOrigin = null;
        this.contentElements = [];
        this.opened = this.element.classList.contains(Lightbox.CLASS_OPEN);
        this.initialTouchY = -1;
    }
    Object.defineProperty(Lightbox, "instance", {
        /**
         * Get lightbox instance
         */
        get: function () {
            if (!Lightbox._instance) {
                Lightbox._instance = new Lightbox();
            }
            return Lightbox._instance;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggle Lightbox full screen mode
     */
    Lightbox.toggleFullScreenMode = function (enabled) {
        Lightbox.fullScreenMode = enabled;
    };
    /**
     * Calculate scroll bar width value
     *
     * @returns Scroll bar width.
     */
    Lightbox.calcScrollWidth = function () {
        return (window.innerWidth - document.body.clientWidth);
    };
    /**
     * Remove scroll bar from document
     *
     * Removes vertical scroll bar and sets right padding with scroll bar size.
     */
    Lightbox.removeDocumentScrollBar = function () {
        var rootStyle = document.documentElement.style;
        var scrollWidth = Lightbox.calcScrollWidth();
        rootStyle.overflowY = 'hidden';
        rootStyle.paddingRight = scrollWidth + 'px';
        document.body.style.overflowY = 'hidden';
    };
    /**
     * Restore scroll bar on document
     */
    Lightbox.restoreDocumentScrollBar = function () {
        var rootStyle = document.documentElement.style;
        rootStyle.overflowY = '';
        rootStyle.paddingRight = '';
        document.body.style.overflowY = '';
    };
    /**
     * Open lightbox window
     *
     * @param elements Lightbox content elements.
     * @param closeCallback Function to call when lightbox closed (or opened
     *  another lightbox).
     */
    Lightbox.prototype.open = function (elements, closeCallback) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.placeContentElements(elements)];
                    case 1:
                        _a.sent();
                        this.addToDocument();
                        Lightbox.removeDocumentScrollBar();
                        this.setOpenState(true);
                        this.addDocumentListeners();
                        this.closeCallback = closeCallback;
                        if (!Lightbox.fullScreenMode) return [3 /*break*/, 3];
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(Lightbox.LIGHTBOX_SHOW_DURATION)];
                    case 2:
                        _a.sent();
                        this.windowScroll = [window.scrollX, window.scrollY];
                        document.body.classList.add(Lightbox.CLASS_BODY_LIGHTBOX_FULLSCREEN);
                        Lightbox.restoreDocumentScrollBar();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Close lightbox window
     */
    Lightbox.prototype.close = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setOpenState(false);
                        this.removeDocumentListeners();
                        if (Lightbox.fullScreenMode) {
                            Lightbox.removeDocumentScrollBar();
                            document.body.classList.remove(Lightbox.CLASS_BODY_LIGHTBOX_FULLSCREEN);
                            window.scrollTo.apply(window, this.windowScroll);
                        }
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(Lightbox.LIGHTBOX_HIDE_DURATION)];
                    case 1:
                        _a.sent();
                        Lightbox.restoreDocumentScrollBar();
                        this.removeFromDocument();
                        return [4 /*yield*/, this.removeContentElements()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Create lightbox DOM elements
     */
    Lightbox.prototype.createElements = function () {
        var _this = this;
        var element = document.createElement('aside');
        element.id = Lightbox.LIGHTBOX_ID;
        var content = document.createElement('div');
        content.className = 'content';
        element.appendChild(content);
        var header = document.createElement('header');
        content.appendChild(header);
        var btnClose = document.createElement('button');
        btnClose.type = 'button';
        btnClose.className = 'close';
        btnClose.textContent = 'Закрыть';
        header.appendChild(btnClose);
        var body = document.createElement('div');
        body.className = 'body';
        content.appendChild(body);
        this.element = element;
        this.body = body;
        btnClose.addEventListener('click', function () { return _this.close(); });
        element.addEventListener('click', function (event) {
            var target = event.target;
            if (target === element) {
                _this.close();
            }
        });
        element.addEventListener('touchstart', this.onLightboxTouchStart);
        element.addEventListener('touchmove', this.onLightboxTouchMove);
    };
    /**
     * Cleanup lightbox content body
     */
    Lightbox.prototype.removeContentElements = function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
            var bodyStyle, withOrigin, fragment, i, n, element;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.contentElements.length === 0) {
                            return [2 /*return*/];
                        }
                        bodyStyle = this.body.style;
                        if (!this.opened) return [3 /*break*/, 3];
                        bodyStyle.opacity = '1';
                        bodyStyle.transition = "opacity " + Lightbox.CONTENT_HIDE_DURATION + "ms";
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(0)];
                    case 1:
                        _a.sent();
                        bodyStyle.opacity = '0';
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(Lightbox.CONTENT_HIDE_DURATION)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        withOrigin = (this.contentOrigin != null);
                        fragment = document.createDocumentFragment();
                        for (i = 0, n = this.contentElements.length; i < n; i++) {
                            element = this.contentElements[i];
                            if (withOrigin) {
                                fragment.appendChild(element);
                            }
                            else {
                                this.body.removeChild(element);
                            }
                        }
                        if (this.contentOrigin != null) {
                            this.contentOrigin.appendChild(fragment);
                        }
                        if (this.opened) {
                            bodyStyle.opacity = '';
                            bodyStyle.transition = '';
                        }
                        if (this.closeCallback) {
                            this.closeCallback();
                            this.closeCallback = undefined;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Place elements to lightbox content body
     */
    Lightbox.prototype.placeContentElements = function (elements) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
            var bodyStyle, fragment, i, n, element;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeContentElements()];
                    case 1:
                        _a.sent();
                        this.contentElements = elements;
                        if (elements.length === 0) {
                            this.contentOrigin = null;
                            return [2 /*return*/];
                        }
                        this.contentOrigin = elements[0].parentNode;
                        bodyStyle = this.body.style;
                        if (!this.opened) return [3 /*break*/, 3];
                        bodyStyle.opacity = '0';
                        bodyStyle.transition = "opacity " + Lightbox.CONTENT_SHOW_DURATION + "ms";
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(0)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        fragment = document.createDocumentFragment();
                        for (i = 0, n = this.contentElements.length; i < n; i++) {
                            element = this.contentElements[i];
                            fragment.appendChild(element);
                        }
                        this.body.appendChild(fragment);
                        if (!this.opened) return [3 /*break*/, 5];
                        bodyStyle.opacity = '1';
                        return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_1__utils_animation_wait__["a" /* default */])(Lightbox.CONTENT_SHOW_DURATION)];
                    case 4:
                        _a.sent();
                        bodyStyle.opacity = '';
                        bodyStyle.transition = '';
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set the open state of lightbox
     *
     * @param state Is lightbox open?
     */
    Lightbox.prototype.setOpenState = function (state) {
        if (state === this.opened) {
            return;
        }
        this.opened = state;
        if (state) {
            this.element.classList.add(Lightbox.CLASS_OPEN);
        }
        else {
            this.element.classList.remove(Lightbox.CLASS_OPEN);
        }
    };
    /**
     * Add lightbox DOM elements to document
     */
    Lightbox.prototype.addToDocument = function () {
        if (this.element.parentElement) {
            return;
        }
        var docBody = document.body;
        docBody.insertBefore(this.element, docBody.firstChild);
    };
    /**
     * Remove lightbox DOM elements from document
     */
    Lightbox.prototype.removeFromDocument = function () {
        if (!this.element.parentElement) {
            return;
        }
        var docBody = document.body;
        docBody.removeChild(this.element);
    };
    /**
     * Add listeners to Document when Lightbox open
     */
    Lightbox.prototype.addDocumentListeners = function () {
        document.addEventListener('keyup', this.onDocumentKeyUp);
    };
    /**
     * Remove listeners from Document when Lightbox close
     */
    Lightbox.prototype.removeDocumentListeners = function () {
        document.removeEventListener('keyup', this.onDocumentKeyUp);
    };
    /**
     * Lightbox element identifier
     */
    Lightbox.LIGHTBOX_ID = 'lightbox';
    /**
     * Class added to lightbox when it's open
     */
    Lightbox.CLASS_OPEN = 'open';
    /**
     * Class added to lightbox when it's open
     */
    Lightbox.CLASS_BODY_LIGHTBOX_FULLSCREEN = 'lightbox-mode-fullscreen';
    /**
     * Duration of hiding previous content
     */
    Lightbox.CONTENT_HIDE_DURATION = 300;
    /**
     * Duration of showing new content
     */
    Lightbox.CONTENT_SHOW_DURATION = 300;
    /**
     * Duration of hiding previous lightbox
     */
    Lightbox.LIGHTBOX_HIDE_DURATION = 300;
    /**
     * Duration of showing new lightbox
     */
    Lightbox.LIGHTBOX_SHOW_DURATION = 300;
    /**
     * Lightbox in full screen mode?
     */
    Lightbox.fullScreenMode = false;
    return Lightbox;
}());
/**
 * Module
 */



/***/ }),

/***/ "PTul":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN_DESKTOP */
/* unused harmony export SCREEN_NOTEBOOK */
/* unused harmony export SCREEN_TABLET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentScreenMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addScreenModeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeScreenModeListener; });

// Параметры экрана
/**
 * Минимальная ширина для настолького компьютера.
 */
var SCREEN_DESKTOP = 1400;
/**
 * Минимальная ширина для ноутбука.
 */
var SCREEN_NOTEBOOK = 1100;
/**
 * Минимальная ширина для планшета.
 */
var SCREEN_TABLET = 700;
/**
 * Слушатели смены режимов экрана.
 */
var screenModeListeners = new Set();
/**
 * Текущий режим экрана.
 */
var currentScreenMode = 3 /* DESKTOP */;
/**
 * Добавление слушателя.
 */
window.addEventListener('resize', onWindowResize);
onWindowResize();
/**
 * Обновить текущий режим экрана в соответствии с шириной.
 *
 * @returns Режим изменился?
 */
function updateCurrentScreenMode() {
    var width = window.innerWidth;
    var mode;
    if (width < SCREEN_TABLET) {
        mode = 0 /* MOBILE */;
    }
    else if (width < SCREEN_NOTEBOOK) {
        mode = 1 /* TABLET */;
    }
    else if (width < SCREEN_DESKTOP) {
        mode = 2 /* NOTEBOOK */;
    }
    else {
        mode = 3 /* DESKTOP */;
    }
    if (mode !== currentScreenMode) {
        currentScreenMode = mode;
        return true;
    }
    return false;
}
/**
 * При изменении размеров экрана.
 */
function onWindowResize() {
    if (updateCurrentScreenMode()) {
        screenModeListeners.forEach(function (listener) { return listener(currentScreenMode); });
    }
}
/**
 * Добавляет слушателя изменения режима экрана.
 * Первый вызов слушателя автоматический после добавления.
 *
 * @param listener Слушатель, получает новый `ScreenMode`.
 */
function addScreenModeListener(listener) {
    screenModeListeners.add(listener);
    listener(currentScreenMode);
}
/**
 * Удаляет слушателя зменения режима экрана.
 *
 * @param listener Удаляемый слушатель.
 */
function removeScreenModeListener(listener) {
    screenModeListeners.delete(listener);
}
/**
 * Возвращает текущий режим экрана.
 */
function getCurrentScreenMode() {
    updateCurrentScreenMode();
    return currentScreenMode;
}
/**
 * Module
 */



/***/ }),

/***/ "Z3hk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertLinkToImage; });

/**
 * Преобразует ссылку на изображение в элемент изображения.
 *
 * Выполняет замену элемента в DOM.
 *
 * @param link Элемент ссылки на изображение.
 */
function convertLinkToImage(link) {
    var parent = link.parentNode;
    var href = link.getAttribute('href');
    if (!parent || !href) {
        return;
    }
    var image = new Image();
    image.alt = link.textContent || '';
    image.src = href;
    parent.replaceChild(image, link);
}
/**
 * Module.
 */



/***/ }),

/***/ "brk0":
/***/ (function(module, exports) {

// Polyfill for creating CustomEvents on IE9/10/11

// code pulled from:
// https://github.com/d4tocchini/customevent-polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill

try {
    var ce = new window.CustomEvent('test');
    ce.preventDefault();
    if (ce.defaultPrevented !== true) {
        // IE has problems with .preventDefault() on custom events
        // http://stackoverflow.com/questions/23349191
        throw new Error('Could not prevent default');
    }
} catch(e) {
  var CustomEvent = function(event, params) {
    var evt, origPrevent;
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };

    evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    origPrevent = evt.preventDefault;
    evt.preventDefault = function () {
      origPrevent.call(this);
      try {
        Object.defineProperty(this, 'defaultPrevented', {
          get: function () {
            return true;
          }
        });
      } catch(e) {
        this.defaultPrevented = true;
      }
    };
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent; // expose definition to window
}


/***/ }),

/***/ "vCxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

/***/ }),

/***/ "z9xy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIntersectionObserverSupported; });

/**
 * IntersectionObserver поддерживается?
 */
var supported = false;
// Проверяем наличие всех нужных объектов единожды при подключении модуля.
if (('IntersectionObserver' in window)
    && ('IntersectionObserverEntry' in window)
    && ('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    // Полифилим свойство isIntersecting для Edge 15.
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
        Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
            get: function () {
                return this.intersectionRatio > 0;
            },
        });
    }
    supported = true;
}
/**
 * Проверяет поддержку IntersectionObserver.
 */
function isIntersectionObserverSupported() {
    return supported;
}
/**
 * Module.
 */



/***/ })

/******/ });


// WEBPACK FOOTER //
// main.a910d777de9ea542b8ff.js